// Toont PDF's als gewone pagina's IN de kassa-software: alles onder elkaar, gewoon scrollen.
// Nodig: npm install pdfjs-dist@3.11.174
import { useEffect, useRef, useState } from "react";
import * as pdfjs from "pdfjs-dist/legacy/build/pdf";
import { api } from "../api";

pdfjs.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

// Eén PDF: wordt pas geladen als hij (bijna) in beeld komt, daarna elke pagina als afbeelding op volle breedte.
export function PdfPaginas({ pad, onFout }) {
  const vak = useRef(null);
  const [zichtbaar, setZichtbaar] = useState(false);
  const [status, setStatus] = useState("wacht");

  useEffect(() => {
    const el = vak.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => e.isIntersecting && setZichtbaar(true), { rootMargin: "800px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!zichtbaar) return;
    let gestopt = false, doc = null;
    (async () => {
      try {
        setStatus("laden");
        const r = await api.get(pad, { responseType: "arraybuffer" });
        doc = await pdfjs.getDocument({ data: new Uint8Array(r.data) }).promise;
        const el = vak.current;
        if (gestopt || !el) return;
        el.innerHTML = "";
        const breedte = Math.min(el.clientWidth || 900, 1100);
        const scherp = Math.min(window.devicePixelRatio || 1, 2);
        for (let n = 1; n <= doc.numPages; n++) {
          if (gestopt) return;
          const pagina = await doc.getPage(n);
          const basis = pagina.getViewport({ scale: 1 });
          const vp = pagina.getViewport({ scale: (breedte / basis.width) * scherp });
          const c = document.createElement("canvas");
          c.width = vp.width;
          c.height = vp.height;
          c.style.width = "100%";
          c.style.maxWidth = `${breedte}px`;
          c.className = "block mx-auto bg-white shadow border border-slate-200 rounded mb-3";
          el.appendChild(c);
          await pagina.render({ canvasContext: c.getContext("2d"), viewport: vp }).promise;
        }
        if (!gestopt) setStatus("klaar");
      } catch (e) {
        if (!gestopt) { setStatus("fout"); onFout?.(e); }
      }
    })();
    return () => { gestopt = true; doc?.destroy(); };
  }, [zichtbaar, pad, onFout]);

  return (
    <div>
      {status !== "klaar" && (
        <div className="h-40 flex items-center justify-center text-slate-400 text-sm bg-slate-50 rounded-lg border border-dashed border-slate-200">
          {status === "fout" ? "PDF kon niet geladen worden" : "PDF laden…"}
        </div>
      )}
      <div ref={vak} />
    </div>
  );
}
